import { useDisclosure } from "@chakra-ui/hooks";
import { Modal, ModalOverlay } from "@chakra-ui/modal";
import React from "react";
import { MdHighlightOff, MdInfoOutline } from "react-icons/md";
import {
  Popover, PopoverTrigger, PopoverContent,
  PopoverHeader, PopoverArrow,
} from "@chakra-ui/react";
import { AIM_STYLES, JsonSection } from "./InfoModal";

const AdvancedInfoModal = ({
  info, varient, client_is_deleted,
}: {
  info?: any; varient?: string; client_is_deleted?: boolean;
}) => {
  const { isOpen, onOpen, onClose } = useDisclosure();
  const [copyPayment, setCopyPayment] = React.useState(false);
  const [copyRefund, setCopyRefund] = React.useState(false);
  const [copyGateway, setCopyGateway] = React.useState(false);
  const [activeTab, setActiveTab] = React.useState("payment");
  const [isCloseModal, setIsCloseModal] = React.useState(false);

  const handleClose = () => { setIsCloseModal(true); setTimeout(() => { setIsCloseModal(false); onClose(); }, 320); };
  const handleOpen = () => { setActiveTab("payment"); onOpen(); };
  const copy = (data: any, setter: (v: boolean) => void) => {
    navigator.clipboard.writeText(JSON.stringify(data, null, 2));
    setter(true); setTimeout(() => setter(false), 1500);
  };

  return (
    <>
      {/* Trigger */}
      <Popover trigger="hover" placement="bottom">
        <PopoverTrigger>
          <button className="txn-action-btn" onClick={handleOpen} disabled={!info} aria-label="View transaction info">
            <MdInfoOutline size={14} />
          </button>
        </PopoverTrigger>
        <PopoverContent border="1px solid #bfdbfe" borderRadius="12px" boxShadow="0 8px 24px rgba(15,23,42,0.08)" bg="#eff6ff" maxW="220px" p="0" overflow="hidden" zIndex="20">
          <PopoverHeader bg="#dbeafe" fontSize="12px" fontWeight="700" color="#1e40af" borderBottom="1px solid #bfdbfe" px="14px" py="10px">View Transaction Info</PopoverHeader>
          <PopoverArrow bg="#eff6ff" />
        </PopoverContent>
      </Popover>

      <Modal isOpen={isOpen} onClose={() => {}}>
        <ModalOverlay bg="rgba(15,23,42,0.55)" backdropFilter="blur(4px)" />

        <div className={`aim-panel${isOpen && !isCloseModal ? " aim-panel--open" : " aim-panel--close"}`}>
          <div className="aim-top-glow" />

          {/* Header */}
          <div className="aim-header">
            <div className="aim-header-brand">
              <div className="aim-header-logo">
                <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="#fff" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                  <circle cx="12" cy="12" r="10"/>
                  <line x1="12" y1="8" x2="12" y2="12"/>
                  <circle cx="12" cy="16" r="0.5" fill="#fff"/>
                </svg>
              </div>
              <div>
                <h2 className="aim-header-title">Payment Info</h2>
                <p className="aim-header-sub">Transaction &amp; gateway response details</p>
              </div>
            </div>
            <button className="aim-close-btn" onClick={handleClose} aria-label="Close"><MdHighlightOff size={22} /></button>
          </div>

          {/* Tab bar */}
          <div className="aim-tab-bar">
            <button
              className={`aim-tab${activeTab === "payment" ? " aim-tab--active" : ""}`}
              onClick={() => setActiveTab("payment")}
            >
              <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                <rect x="1" y="4" width="22" height="16" rx="2"/><line x1="1" y1="10" x2="23" y2="10"/>
              </svg>
              Payment Response
            </button>
            <button
              className={`aim-tab${activeTab === "gateway" ? " aim-tab--active" : ""}`}
              onClick={() => setActiveTab("gateway")}
            >
              <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                <path d="M5 12h14M12 5l7 7-7 7"/>
              </svg>
              Gateway Response
            </button>
          </div>

          {/* Body */}
          <div className="aim-body">
            {activeTab === "payment" && (
              <div className="aim-content-area">
                <JsonSection
                  label="Payment Response" dotColor="blue"
                  data={info?.meta_info} copied={copyPayment}
                  onCopy={() => copy(info?.meta_info, setCopyPayment)}
                />
                {info?.refund_info && (
                  <JsonSection
                    label="Refund Info" dotColor="amber"
                    data={info?.refund_info} copied={copyRefund}
                    onCopy={() => copy(info?.refund_info, setCopyRefund)}
                  />
                )}
              </div>
            )}
            {activeTab === "gateway" && (
              <div className="aim-content-area">
                <JsonSection
                  label="Gateway Response" dotColor="green"
                  data={info?.gateway_response} copied={copyGateway}
                  onCopy={() => copy(info?.gateway_response, setCopyGateway)}
                />
              </div>
            )}
          </div>

          {/* Footer */}
          <div className="aim-footer">
            <div className="aim-footer-note">
              <svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                <circle cx="12" cy="12" r="10"/>
                <line x1="12" y1="8" x2="12" y2="12"/>
                <line x1="12" y1="16" x2="12.01" y2="16"/>
              </svg>
              Read-only transaction data
            </div>
            <button className="aim-btn-close" onClick={handleClose}>Close</button>
          </div>
        </div>
      </Modal>

      {AIM_STYLES}
    </>
  );
};

export default AdvancedInfoModal;